"use client";
// The subdomain family renders OUTSIDE the dashboard tree, so it carries its
// own SessionProvider — useSession() in the landings/account hub needs one.
// It also fires the one-line landing beacon that feeds the admin funnel:
// host + path + referrer, nothing more, throttled server-side.
import { useEffect } from "react";
import { SessionProvider } from "next-auth/react";

export default function SubdomainsLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    try {
      fetch("/api/v5/public/track", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          host: window.location.hostname,
          path: window.location.pathname,
          referrer: document.referrer || "",
        }),
        keepalive: true,
      }).catch(() => {});
    } catch { /* analytics must never break the page */ }
  }, []);
  return <SessionProvider>{children}</SessionProvider>;
}
